import { create } from 'zustand';

interface ErrorState {
  isFatalError: boolean;
  setFatalError: (value: boolean) => void;
}

export const useErrorStore = create<ErrorState>((set) => ({
  isFatalError: false,
  setFatalError: (value) => set({ isFatalError: value }),
}));